// extracted by mini-css-extract-plugin
module.exports = {"amount_list":"LIstOperations_amount_list__2FFyV"};